// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__1goJC","log":"ModalInventoryLogs_log__-sG5V","date":"ModalInventoryLogs_date__3i1YB","userName":"ModalInventoryLogs_userName__3XLS-"};